import type { OpUnitType, QUnitType } from 'dayjs';

export const THEME_COLOR = 'var(--atlas-bg-surface-alpha-60)';

export type LockTimeType = {
	duration: number;
	difference: OpUnitType | QUnitType;
};

export const AGENTS = { TappExchange: 'Tapp Exchange' };

export const MAX_AMOUNT_ALLOWED = 1000;
export const MIN_AMOUNT_ALLOWED = 5;
